import { forwardRef } from 'react'
import clsx from 'clsx'

type SectionProps = {
    as?: React.ElementType
    children: React.ReactNode
    width?: 'default' | 'full' | 'narrow' | 'wide'
    display?: 'block' | 'flex' | 'grid'
    id?: string
    className?: string
}

export const Section = forwardRef<HTMLElement, SectionProps>(
    (
        {
            as: Component = 'section',
            width = 'default',
            display = 'grid',
            children,
            id = '',
            className = '',
            ...props
        },
        ref
    ) => {
        const widths: Record<string, string> = {
            default: 'w-default',
            full: 'w-full',
            narrow: 'w-narrow',
            wide: 'w-wide'
        }

        const displays: Record<'block' | 'flex' | 'grid', string> = {
            block: 'block',
            flex: 'flex',
            grid: 'grid'
        }

        const styles = clsx(
            'mx-auto',
            widths[width],
            displays[display],
            className
        )
        return (
            <Component {...props} id={id} className={styles} ref={ref}>
                {children}
            </Component>
        )
    }
)
